import React from 'react'
import styled from 'styled-components'

const StyledSvg = styled.svg<{ expanded: boolean }>`
  transform: ${(props) => (props.expanded ? 'rotate(180deg)' : 'none')};
  transition: transform 0.3s ease;
`

interface OpenArrowProps {
  expanded?: boolean
}

const OpenArrow: React.FC<OpenArrowProps> = ({ expanded }) => {
  return (
    <StyledSvg
      expanded={expanded ?? false}
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.192211 0.39075C0.448493 0.136351 0.864007 0.136351 1.12029 0.39075L7 6.22726L12.8797 0.39075C13.136 0.136352 13.5515 0.136352 13.8078 0.39075C14.0641 0.645149 14.0641 1.05761 13.8078 1.31201L7.46404 7.60915C7.20776 7.86355 6.79224 7.86355 6.53596 7.60915L0.192211 1.31201C-0.0640704 1.05761 -0.0640704 0.645149 0.192211 0.39075Z"
        fill="#B3B3B3"
      />
    </StyledSvg>
  )
}

export default OpenArrow
